/**
 * Pre-computed country codes with flags
 * Flags are static Unicode emoji - no runtime computation needed
 */

export const COUNTRY_CODES = Object.freeze({
  '+93': { code: '+93', iso: 'AF', flag: '🇦🇫' },
  '+355': { code: '+355', iso: 'AL', flag: '🇦🇱' },
  '+213': { code: '+213', iso: 'DZ', flag: '🇩🇿' },
  '+1684': { code: '+1684', iso: 'AS', flag: '🇦🇸' },
  '+376': { code: '+376', iso: 'AD', flag: '🇦🇩' },
  '+244': { code: '+244', iso: 'AO', flag: '🇦🇴' },
  '+1264': { code: '+1264', iso: 'AI', flag: '🇦🇮' },
  '+672': { code: '+672', iso: 'AQ', flag: '🇦🇶' },
  '+1268': { code: '+1268', iso: 'AG', flag: '🇦🇬' },
  '+54': { code: '+54', iso: 'AR', flag: '🇦🇷' },
  '+374': { code: '+374', iso: 'AM', flag: '🇦🇲' },
  '+297': { code: '+297', iso: 'AW', flag: '🇦🇼' },
  '+61': { code: '+61', iso: 'AU', flag: '🇦🇺' },
  '+43': { code: '+43', iso: 'AT', flag: '🇦🇹' },
  '+994': { code: '+994', iso: 'AZ', flag: '🇦🇿' },
  '+1242': { code: '+1242', iso: 'BS', flag: '🇧🇸' },
  '+973': { code: '+973', iso: 'BH', flag: '🇧🇭' },
  '+880': { code: '+880', iso: 'BD', flag: '🇧🇩' },
  '+1246': { code: '+1246', iso: 'BB', flag: '🇧🇧' },
  '+375': { code: '+375', iso: 'BY', flag: '🇧🇾' },
  '+32': { code: '+32', iso: 'BE', flag: '🇧🇪' },
  '+501': { code: '+501', iso: 'BZ', flag: '🇧🇿' },
  '+229': { code: '+229', iso: 'BJ', flag: '🇧🇯' },
  '+1441': { code: '+1441', iso: 'BM', flag: '🇧🇲' },
  '+975': { code: '+975', iso: 'BT', flag: '🇧🇹' },
  '+591': { code: '+591', iso: 'BO', flag: '🇧🇴' },
  '+387': { code: '+387', iso: 'BA', flag: '🇧🇦' },
  '+267': { code: '+267', iso: 'BW', flag: '🇧🇼' },
  '+55': { code: '+55', iso: 'BR', flag: '🇧🇷' },
  '+246': { code: '+246', iso: 'IO', flag: '🇮🇴' },
  '+673': { code: '+673', iso: 'BN', flag: '🇧🇳' },
  '+359': { code: '+359', iso: 'BG', flag: '🇧🇬' },
  '+226': { code: '+226', iso: 'BF', flag: '🇧🇫' },
  '+257': { code: '+257', iso: 'BI', flag: '🇧🇮' },
  '+855': { code: '+855', iso: 'KH', flag: '🇰🇭' },
  '+237': { code: '+237', iso: 'CM', flag: '🇨🇲' },
  '+1': { code: '+1', iso: 'US', flag: '🇺🇸', name: 'United States' },
  '+1-CA': { code: '+1', iso: 'CA', flag: '🇨🇦', name: 'Canada' },
  '+238': { code: '+238', iso: 'CV', flag: '🇨🇻' },
  '+1345': { code: '+1345', iso: 'KY', flag: '🇰🇾' },
  '+236': { code: '+236', iso: 'CF', flag: '🇨🇫' },
  '+235': { code: '+235', iso: 'TD', flag: '🇹🇩' },
  '+56': { code: '+56', iso: 'CL', flag: '🇨🇱' },
  '+86': { code: '+86', iso: 'CN', flag: '🇨🇳' },
  '+57': { code: '+57', iso: 'CO', flag: '🇨🇴' },
  '+269': { code: '+269', iso: 'KM', flag: '🇰🇲' },
  '+242': { code: '+242', iso: 'CG', flag: '🇨🇬' },
  '+243': { code: '+243', iso: 'CD', flag: '🇨🇩' },
  '+682': { code: '+682', iso: 'CK', flag: '🇨🇰' },
  '+506': { code: '+506', iso: 'CR', flag: '🇨🇷' },
  '+225': { code: '+225', iso: 'CI', flag: '🇨🇮' },
  '+385': { code: '+385', iso: 'HR', flag: '🇭🇷' },
  '+53': { code: '+53', iso: 'CU', flag: '🇨🇺' },
  '+599': { code: '+599', iso: 'CW', flag: '🇨🇼' },
  '+357': { code: '+357', iso: 'CY', flag: '🇨🇾' },
  '+420': { code: '+420', iso: 'CZ', flag: '🇨🇿' },
  '+45': { code: '+45', iso: 'DK', flag: '🇩🇰' },
  '+253': { code: '+253', iso: 'DJ', flag: '🇩🇯' },
  '+1767': { code: '+1767', iso: 'DM', flag: '🇩🇲' },
  '+1809': { code: '+1809', iso: 'DO', flag: '🇩🇴' },
  '+593': { code: '+593', iso: 'EC', flag: '🇪🇨' },
  '+20': { code: '+20', iso: 'EG', flag: '🇪🇬' },
  '+503': { code: '+503', iso: 'SV', flag: '🇸🇻' },
  '+240': { code: '+240', iso: 'GQ', flag: '🇬🇶' },
  '+291': { code: '+291', iso: 'ER', flag: '🇪🇷' },
  '+372': { code: '+372', iso: 'EE', flag: '🇪🇪' },
  '+251': { code: '+251', iso: 'ET', flag: '🇪🇹' },
  '+500': { code: '+500', iso: 'FK', flag: '🇫🇰' },
  '+298': { code: '+298', iso: 'FO', flag: '🇫🇴' },
  '+679': { code: '+679', iso: 'FJ', flag: '🇫🇯' },
  '+358': { code: '+358', iso: 'FI', flag: '🇫🇮' },
  '+33': { code: '+33', iso: 'FR', flag: '🇫🇷' },
  '+594': { code: '+594', iso: 'GF', flag: '🇬🇫' },
  '+689': { code: '+689', iso: 'PF', flag: '🇵🇫' },
  '+241': { code: '+241', iso: 'GA', flag: '🇬🇦' },
  '+220': { code: '+220', iso: 'GM', flag: '🇬🇲' },
  '+995': { code: '+995', iso: 'GE', flag: '🇬🇪' },
  '+49': { code: '+49', iso: 'DE', flag: '🇩🇪' },
  '+233': { code: '+233', iso: 'GH', flag: '🇬🇭' },
  '+350': { code: '+350', iso: 'GI', flag: '🇬🇮' },
  '+30': { code: '+30', iso: 'GR', flag: '🇬🇷' },
  '+299': { code: '+299', iso: 'GL', flag: '🇬🇱' },
  '+1473': { code: '+1473', iso: 'GD', flag: '🇬🇩' },
  '+590': { code: '+590', iso: 'GP', flag: '🇬🇵' },
  '+1671': { code: '+1671', iso: 'GU', flag: '🇬🇺' },
  '+502': { code: '+502', iso: 'GT', flag: '🇬🇹' },
  '+44': { code: '+44', iso: 'UK', flag: '🇬🇧', name: 'United Kingdom', aliases: ['GB', 'Great Britain'] },
  '+224': { code: '+224', iso: 'GN', flag: '🇬🇳' },
  '+245': { code: '+245', iso: 'GW', flag: '🇬🇼' },
  '+592': { code: '+592', iso: 'GY', flag: '🇬🇾' },
  '+509': { code: '+509', iso: 'HT', flag: '🇭🇹' },
  '+504': { code: '+504', iso: 'HN', flag: '🇭🇳' },
  '+852': { code: '+852', iso: 'HK', flag: '🇭🇰' },
  '+36': { code: '+36', iso: 'HU', flag: '🇭🇺' },
  '+354': { code: '+354', iso: 'IS', flag: '🇮🇸' },
  '+91': { code: '+91', iso: 'IN', flag: '🇮🇳' },
  '+62': { code: '+62', iso: 'ID', flag: '🇮🇩' },
  '+98': { code: '+98', iso: 'IR', flag: '🇮🇷' },
  '+964': { code: '+964', iso: 'IQ', flag: '🇮🇶' },
  '+353': { code: '+353', iso: 'IE', flag: '🇮🇪' },
  '+972': { code: '+972', iso: 'IL', flag: '🇮🇱' },
  '+39': { code: '+39', iso: 'IT', flag: '🇮🇹' },
  '+1876': { code: '+1876', iso: 'JM', flag: '🇯🇲' },
  '+81': { code: '+81', iso: 'JP', flag: '🇯🇵' },
  '+962': { code: '+962', iso: 'JO', flag: '🇯🇴' },
  '+7': { code: '+7', iso: 'KZ', flag: '🇰🇿' },
  '+254': { code: '+254', iso: 'KE', flag: '🇰🇪' },
  '+686': { code: '+686', iso: 'KI', flag: '🇰🇮' },
  '+850': { code: '+850', iso: 'KP', flag: '🇰🇵' },
  '+82': { code: '+82', iso: 'KR', flag: '🇰🇷' },
  '+965': { code: '+965', iso: 'KW', flag: '🇰🇼' },
  '+996': { code: '+996', iso: 'KG', flag: '🇰🇬' },
  '+856': { code: '+856', iso: 'LA', flag: '🇱🇦' },
  '+371': { code: '+371', iso: 'LV', flag: '🇱🇻' },
  '+961': { code: '+961', iso: 'LB', flag: '🇱🇧' },
  '+266': { code: '+266', iso: 'LS', flag: '🇱🇸' },
  '+231': { code: '+231', iso: 'LR', flag: '🇱🇷' },
  '+218': { code: '+218', iso: 'LY', flag: '🇱🇾' },
  '+423': { code: '+423', iso: 'LI', flag: '🇱🇮' },
  '+370': { code: '+370', iso: 'LT', flag: '🇱🇹' },
  '+352': { code: '+352', iso: 'LU', flag: '🇱🇺' },
  '+853': { code: '+853', iso: 'MO', flag: '🇲🇴' },
  '+389': { code: '+389', iso: 'MK', flag: '🇲🇰' },
  '+261': { code: '+261', iso: 'MG', flag: '🇲🇬' },
  '+265': { code: '+265', iso: 'MW', flag: '🇲🇼' },
  '+60': { code: '+60', iso: 'MY', flag: '🇲🇾' },
  '+960': { code: '+960', iso: 'MV', flag: '🇲🇻' },
  '+223': { code: '+223', iso: 'ML', flag: '🇲🇱' },
  '+356': { code: '+356', iso: 'MT', flag: '🇲🇹' },
  '+692': { code: '+692', iso: 'MH', flag: '🇲🇭' },
  '+596': { code: '+596', iso: 'MQ', flag: '🇲🇶' },
  '+222': { code: '+222', iso: 'MR', flag: '🇲🇷' },
  '+230': { code: '+230', iso: 'MU', flag: '🇲🇺' },
  '+262': { code: '+262', iso: 'YT', flag: '🇾🇹' },
  '+52': { code: '+52', iso: 'MX', flag: '🇲🇽' },
  '+691': { code: '+691', iso: 'FM', flag: '🇫🇲' },
  '+373': { code: '+373', iso: 'MD', flag: '🇲🇩' },
  '+377': { code: '+377', iso: 'MC', flag: '🇲🇨' },
  '+976': { code: '+976', iso: 'MN', flag: '🇲🇳' },
  '+382': { code: '+382', iso: 'ME', flag: '🇲🇪' },
  '+1664': { code: '+1664', iso: 'MS', flag: '🇲🇸' },
  '+212': { code: '+212', iso: 'MA', flag: '🇲🇦' },
  '+258': { code: '+258', iso: 'MZ', flag: '🇲🇿' },
  '+95': { code: '+95', iso: 'MM', flag: '🇲🇲' },
  '+264': { code: '+264', iso: 'NA', flag: '🇳🇦' },
  '+674': { code: '+674', iso: 'NR', flag: '🇳🇷' },
  '+977': { code: '+977', iso: 'NP', flag: '🇳🇵' },
  '+31': { code: '+31', iso: 'NL', flag: '🇳🇱' },
  '+687': { code: '+687', iso: 'NC', flag: '🇳🇨' },
  '+64': { code: '+64', iso: 'NZ', flag: '🇳🇿' },
  '+505': { code: '+505', iso: 'NI', flag: '🇳🇮' },
  '+227': { code: '+227', iso: 'NE', flag: '🇳🇪' },
  '+234': { code: '+234', iso: 'NG', flag: '🇳🇬' },
  '+683': { code: '+683', iso: 'NU', flag: '🇳🇺' },
  '+1670': { code: '+1670', iso: 'MP', flag: '🇲🇵' },
  '+47': { code: '+47', iso: 'NO', flag: '🇳🇴' },
  '+968': { code: '+968', iso: 'OM', flag: '🇴🇲' },
  '+92': { code: '+92', iso: 'PK', flag: '🇵🇰' },
  '+680': { code: '+680', iso: 'PW', flag: '🇵🇼' },
  '+970': { code: '+970', iso: 'PS', flag: '🇵🇸' },
  '+507': { code: '+507', iso: 'PA', flag: '🇵🇦' },
  '+675': { code: '+675', iso: 'PG', flag: '🇵🇬' },
  '+595': { code: '+595', iso: 'PY', flag: '🇵🇾' },
  '+51': { code: '+51', iso: 'PE', flag: '🇵🇪' },
  '+63': { code: '+63', iso: 'PH', flag: '🇵🇭' },
  '+48': { code: '+48', iso: 'PL', flag: '🇵🇱' },
  '+351': { code: '+351', iso: 'PT', flag: '🇵🇹' },
  '+1787': { code: '+1787', iso: 'PR', flag: '🇵🇷' },
  '+974': { code: '+974', iso: 'QA', flag: '🇶🇦' },
  '+40': { code: '+40', iso: 'RO', flag: '🇷🇴' },
  '+250': { code: '+250', iso: 'RW', flag: '🇷🇼' },
  '+290': { code: '+290', iso: 'SH', flag: '🇸🇭' },
  '+1869': { code: '+1869', iso: 'KN', flag: '🇰🇳' },
  '+1758': { code: '+1758', iso: 'LC', flag: '🇱🇨' },
  '+508': { code: '+508', iso: 'PM', flag: '🇵🇲' },
  '+1784': { code: '+1784', iso: 'VC', flag: '🇻🇨' },
  '+685': { code: '+685', iso: 'WS', flag: '🇼🇸' },
  '+378': { code: '+378', iso: 'SM', flag: '🇸🇲' },
  '+239': { code: '+239', iso: 'ST', flag: '🇸🇹' },
  '+966': { code: '+966', iso: 'SA', flag: '🇸🇦' },
  '+221': { code: '+221', iso: 'SN', flag: '🇸🇳' },
  '+381': { code: '+381', iso: 'RS', flag: '🇷🇸' },
  '+248': { code: '+248', iso: 'SC', flag: '🇸🇨' },
  '+232': { code: '+232', iso: 'SL', flag: '🇸🇱' },
  '+65': { code: '+65', iso: 'SG', flag: '🇸🇬' },
  '+1721': { code: '+1721', iso: 'SX', flag: '🇸🇽' },
  '+421': { code: '+421', iso: 'SK', flag: '🇸🇰' },
  '+386': { code: '+386', iso: 'SI', flag: '🇸🇮' },
  '+677': { code: '+677', iso: 'SB', flag: '🇸🇧' },
  '+252': { code: '+252', iso: 'SO', flag: '🇸🇴' },
  '+27': { code: '+27', iso: 'ZA', flag: '🇿🇦' },
  '+211': { code: '+211', iso: 'SS', flag: '🇸🇸' },
  '+34': { code: '+34', iso: 'ES', flag: '🇪🇸' },
  '+94': { code: '+94', iso: 'LK', flag: '🇱🇰' },
  '+249': { code: '+249', iso: 'SD', flag: '🇸🇩' },
  '+597': { code: '+597', iso: 'SR', flag: '🇸🇷' },
  '+268': { code: '+268', iso: 'SZ', flag: '🇸🇿' },
  '+46': { code: '+46', iso: 'SE', flag: '🇸🇪' },
  '+41': { code: '+41', iso: 'CH', flag: '🇨🇭' },
  '+963': { code: '+963', iso: 'SY', flag: '🇸🇾' },
  '+886': { code: '+886', iso: 'TW', flag: '🇹🇼' },
  '+992': { code: '+992', iso: 'TJ', flag: '🇹🇯' },
  '+255': { code: '+255', iso: 'TZ', flag: '🇹🇿' },
  '+66': { code: '+66', iso: 'TH', flag: '🇹🇭' },
  '+670': { code: '+670', iso: 'TL', flag: '🇹🇱' },
  '+228': { code: '+228', iso: 'TG', flag: '🇹🇬' },
  '+690': { code: '+690', iso: 'TK', flag: '🇹🇰' },
  '+676': { code: '+676', iso: 'TO', flag: '🇹🇴' },
  '+1868': { code: '+1868', iso: 'TT', flag: '🇹🇹' },
  '+216': { code: '+216', iso: 'TN', flag: '🇹🇳' },
  '+90': { code: '+90', iso: 'TR', flag: '🇹🇷' },
  '+993': { code: '+993', iso: 'TM', flag: '🇹🇲' },
  '+1649': { code: '+1649', iso: 'TC', flag: '🇹🇨' },
  '+688': { code: '+688', iso: 'TV', flag: '🇹🇻' },
  '+256': { code: '+256', iso: 'UG', flag: '🇺🇬' },
  '+380': { code: '+380', iso: 'UA', flag: '🇺🇦' },
  '+971': { code: '+971', iso: 'AE', flag: '🇦🇪' },
  '+598': { code: '+598', iso: 'UY', flag: '🇺🇾' },
  '+998': { code: '+998', iso: 'UZ', flag: '🇺🇿' },
  '+678': { code: '+678', iso: 'VU', flag: '🇻🇺' },
  '+379': { code: '+379', iso: 'VA', flag: '🇻🇦' },
  '+58': { code: '+58', iso: 'VE', flag: '🇻🇪' },
  '+84': { code: '+84', iso: 'VN', flag: '🇻🇳' },
  '+1284': { code: '+1284', iso: 'VG', flag: '🇻🇬' },
  '+1340': { code: '+1340', iso: 'VI', flag: '🇻🇮' },
  '+681': { code: '+681', iso: 'WF', flag: '🇼🇫' },
  '+967': { code: '+967', iso: 'YE', flag: '🇾🇪' },
  '+260': { code: '+260', iso: 'ZM', flag: '🇿🇲' },
  '+263': { code: '+263', iso: 'ZW', flag: '🇿🇼' }
});

// Pre-built search index for faster lookups (sorted by code length descending)
export const COUNTRY_CODE_SEARCH_INDEX = Object.entries(COUNTRY_CODES)
  .map(([key, data]) => ({
    ...data,
    searchKey: `${data.code}${data.iso}${data.name || ''}${(data.aliases || []).join('')}`.toLowerCase()
  }));

// Sorted codes for prefix matching (longest first)
export const SORTED_COUNTRY_CODES = Object.keys(COUNTRY_CODES)
  .sort((a, b) => b.length - a.length);

/**
 * Filter countries by search input (code, ISO, or name)
 * Prioritizes exact code matches, then codes starting with input
 * @param {string} input - Search term
 * @param {number} maxResults - Maximum results to return
 * @returns {Array} Matching country data
 */
export const filterCountries = (input, maxResults = 5) => {
  if (!input || input.length < 1) return [];
  const term = input.toLowerCase().trim();
  const termWithPlus = term.startsWith('+') ? term : '+' + term.replace(/^\+*/, '');
  const termDigits = term.replace(/[^\d]/g, '');
  const termLetters = term.replace(/[^a-z]/gi, '').toLowerCase();
  
  // Get all matches
  let matches = COUNTRY_CODE_SEARCH_INDEX.filter(c => c.searchKey.includes(term));
  
  // If user is typing digits (like "44"), filter out countries whose codes DON'T contain those digits
  // This prevents +1 (US) from appearing when user types "44"
  if (termDigits && termDigits.length > 0) {
    matches = matches.filter(c => {
      const codeDigits = c.code.replace(/[^\d]/g, '');
      // Keep if: code contains the search digits OR name/iso contains the search term
      return codeDigits.includes(termDigits) || 
             c.iso.toLowerCase().includes(termLetters) || 
             (c.name && c.name.toLowerCase().includes(termLetters)) ||
             (c.aliases && c.aliases.some(a => a.toLowerCase().includes(termLetters)));
    });
  }
  
  // Sort: exact code matches first, then codes starting with input, then by relevance
  matches.sort((a, b) => {
    const aCode = a.code.toLowerCase();
    const bCode = b.code.toLowerCase();
    
    // Exact match gets highest priority
    const aExact = aCode === termWithPlus;
    const bExact = bCode === termWithPlus;
    if (aExact && !bExact) return -1;
    if (!aExact && bExact) return 1;
    
    // Code starting with search term gets second priority
    const aStartsWith = aCode.startsWith(termWithPlus);
    const bStartsWith = bCode.startsWith(termWithPlus);
    if (aStartsWith && !bStartsWith) return -1;
    if (!aStartsWith && bStartsWith) return 1;
    
    // If both start with the term, shorter code = closer match
    if (aStartsWith && bStartsWith) {
      return aCode.length - bCode.length;
    }
    
    // For non-code matches (name/ISO matches), prefer where code contains the search digits
    if (termDigits) {
      const aCodeContainsTerm = aCode.includes(termDigits);
      const bCodeContainsTerm = bCode.includes(termDigits);
      if (aCodeContainsTerm && !bCodeContainsTerm) return -1;
      if (!aCodeContainsTerm && bCodeContainsTerm) return 1;
    }
    
    // Otherwise maintain alphabetical order by searchKey (stable, predictable)
    return a.searchKey.localeCompare(b.searchKey);
  });
  
  return matches.slice(0, maxResults);
};

/**
 * Recognize country code from phone number prefix
 * @param {string} input - Phone number or partial input
 * @returns {Object|null} Country data or null if not found
 */
export const recognizeCountryCode = (input) => {
  if (!input || input.length === 0) return null;
  
  // Clean input - keep + at start, digits only
  let cleanInput = input.replace(/[^\d+]/g, '');
  if (!cleanInput.startsWith('+')) {
    cleanInput = '+' + cleanInput.replace(/^\+*/, '');
  }
  
  // Try exact match first
  if (COUNTRY_CODES[cleanInput]) {
    return { code: cleanInput, ...COUNTRY_CODES[cleanInput] };
  }
  
  // Try prefix match (longest codes first)
  for (const code of SORTED_COUNTRY_CODES) {
    if (cleanInput.startsWith(code)) {
      return { code, ...COUNTRY_CODES[code] };
    }
  }
  
  return null;
};
